export default {
  // Endpoints
  loginEndpoint: `${process.env.VUE_APP_API_URL}api/auth/jwt/create`,
  //loginEndpoint: '/jwt/login',
  getUser: `${process.env.VUE_APP_API_URL}api/auth/users/me/`,
  registerEndpoint: '/jwt/register',
  refreshEndpoint: `${process.env.VUE_APP_API_URL}api/auth/jwt/refresh`,
  logoutEndpoint: '/jwt/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
